export const GOOGLE = window.google;
